import React from 'react';
import styled from 'styled-components';
import sharedStyles from '../styles';

const Container = styled.div`
  display: flex;
  margin-right: ${sharedStyles.spacing['spacing-1xs']};
`;

const StaticSvg = styled.img`
  display: block;
  height: 20px;
`;

interface UploadedSvgIconProps {
  url: string;
  alt?: string;
}

function UploadedSvgIcon({
  url,
  alt = 'notification icon',
}: Readonly<UploadedSvgIconProps>) {
  return (
    <Container>
      <StaticSvg
        aria-hidden="true"
        src={url}
        alt={alt}
        width="100%"
        height="auto"
      />
    </Container>
  );
}

export default UploadedSvgIcon;
